import { handleApiError } from './errorHandling';

export async function handleApiRequest<T>(operation: () => Promise<T>): Promise<T> {
  try {
    return await operation();
  } catch (error) {
    throw handleApiError(error);
  }
}
